<template>
    <div>
        <div class="form-group my-2 flex phone-number-row">
            <label
                for="checkout_phone_number"
                class="label-required flex"
            >
                <b>{{ __('Phone') }}</b>
            </label>
            <phone-number-field
                :fix-country-code="checkoutData.phoneNumberFixCountryCode"
                :country-code="phoneNumber.countryCode"
                :prefix="phoneNumber.prefix"
                :line-number="phoneNumber.lineNumber"
                :default-country-id="phoneDefaultCountryId"
                :errors="errors"
                @input="phoneNumber = $event"
            />
        </div>
        <small class="form-text text-muted">
            {{ __('Kérjük, hogy olyan mobiltelefonszámot adj meg, amely a szállítási országban érvényes, mert a futár csak ezen tud hívni!') }}
        </small>

        <template v-if="shippable && !selectedShippingModeHasPickupPoints">
            <shipping-address-selector
                v-model="shippingAddress"
                :addresses="shippingAddresses"
                :countries="checkoutData.countries"
            >
                <template v-slot:header>
                    <span class="shipping-addresses-title">
                        <b>{{ __('Shipping Addresses') }}</b>
                        <span class="shipping-addresses-info">
                            {{ __('(Please, select the shipping address!)') }}
                        </span>
                    </span>
                </template>
            </shipping-address-selector>
            <form-error
                :errors="errors"
                field="shippingAddressId"
                style="display: block"
            />
        </template>

        <billing-address-selector
            v-model="billingAddress"
            :addresses="billingAddresses"
            :countries="checkoutData.countries"
        >
            <template v-slot:header>
                <span class="billing-addresses-title">
                    <b>{{ __('Billing Addresses') }}</b>
                    <span class="billing-addresses-info">
                        {{ __('(Please, select the billing address!)') }}
                    </span>
                </span>
            </template>
        </billing-address-selector>
        <form-error
            :errors="errors"
            field="billingAddressId"
            style="display: block"
        />
        <form-error
            :errors="errors"
            field="vatNumber"
            style="display: block"
        />
        <form-error
            field="internationalShipping"
            :errors="errors"
        />
    </div>
</template>

<script>
import authenticatedCustomerDataBase from '@webapix/shop-js/src/mixins/checkout/authenticatedCustomerDataBase'

export default {
    name: 'AuthenticatedCustomerDataForm',
    mixins: [authenticatedCustomerDataBase],

    computed: {
        phoneDefaultCountryId() {
            const address = this.shippingAddresses.find(shippingAddress => shippingAddress.id == this.shippingAddress)

            return address ? address.countryId : null
        }
    }
}
</script>
